import gallery from './gallery.js';
import index from './index.js';
import { Router } from '@/legacy/Router';
import slideshow from './slideshow.js';

Router.get('gallery/([a-zA-Z]+)', index);
Router.get('gallery/([a-zA-Z]+)/([a-zA-Z]+)', gallery);
Router.get('gallery/([a-zA-Z]+)/([a-zA-Z]+)/slideshow', slideshow);
Router.get('gallery/([a-zA-Z]+)/([a-zA-Z]+)/(?!slideshow)([a-zA-Z]+)', gallery);
